import { Tracker } from '@goeuro/app/client/tracking-provider/src/tracking/PoC/universalTracker/universalTracker'
import { decodeWasabiContexts } from '@goeuro/app/client/tracking-provider/src/utils/wasabiQueryUtils'
import { logInfo } from '../../shared/logger';
import { Redirect } from '../../shared/types/Redirect';
import { monetizationTransferPageRedirect } from './events/transfer-page-system';
import { PageTypeContext } from './contexts';

let instance: Tracker | null = null
let hasWasabiInitialized = false
const pageTypeContext = new PageTypeContext({
  page_type: 'monetization-transfer-page'
})

export const initWasabiContexts = (hash: string) => {
  if (!instance) instance = new Tracker();
  if (hasWasabiInitialized) return
  const wasabiContexts = decodeWasabiContexts(hash)
  if (wasabiContexts.length) {
    instance.initializeWasabiContexts(wasabiContexts)
    hasWasabiInitialized = true
  }
}

export const trackRedirectEvent = (redirect: Redirect, forced = false): void => {
  if (!instance) instance = new Tracker();
  const { campaign, payload, partnerName, queryParams } = redirect;

  const {
    departureId: depPosId,
    departureDate: depDate,
    arrivalId: tarPosId,
    locale,
    currency,
    returnDate: retDate,
    siteLocation: siteLoc,
  } = payload;

  const { trackInfo } = queryParams;

  const arrival_position_id = parseInt(tarPosId, 10) || 0;
  const departure_date = depDate || '';
  const departure_position_id = parseInt(depPosId, 10) || 0;
  const monetization_campaign = campaign || 'Unknown';
  const monetization_partner = partnerName || 'Unknown';
  const monetization_source = 'Omio';
  const return_date = retDate || '';
  const site_loc = siteLoc || 'Unknown';
  const component = payload.component || 'Unknown';
  const platform = payload.platform || 'Unknown';
  const track_info = trackInfo || 'Unknown';

  const redirectEvent = {
    arrival_position_id,
    currency,
    departure_date,
    departure_position_id,
    forced,
    locale,
    monetization_campaign,
    monetization_partner,
    monetization_source,
    return_date,
    site_loc,
    component,
    platform,
    track_info,
  };

  logInfo(`Redirect event from site location of ${site_loc}:`, redirectEvent);

  instance.trackEvent(monetizationTransferPageRedirect, redirectEvent, [pageTypeContext]);
};